import { yupEnum, yupNumber, yupObject } from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export const SHIPPER_RATINGS_PAGE_SIZE = 10;

const RATINGS_SORT_OPTIONS = [
  'newest',
  'negative-ratings',
  'positive-ratings',
] as const;
export type RatingSortOption = (typeof RATINGS_SORT_OPTIONS)[number];

export type ShipperProfilePageParams = InferType<
  typeof shipperProfilePageParamsSchema
>;
export const shipperProfilePageParamsSchema = yupObject({
  page: yupNumber().default(1).nullable(false),
  size: yupNumber().default(SHIPPER_RATINGS_PAGE_SIZE).nullable(false),
  sort: yupEnum(RATINGS_SORT_OPTIONS, 'newest'),
  tab: yupEnum(['overview', 'ratings']).default('overview'),
});
